import script from "./PersonaChat.vue?vue&type=script&lang=ts&setup=true"
export * from "./PersonaChat.vue?vue&type=script&lang=ts&setup=true"

import "./PersonaChat.vue?vue&type=style&index=0&id=d56ff87e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d56ff87e"]])

export default __exports__